import React, { Fragment, useEffect, useState } from 'react';
import {css, Global, keyframes} from '@emotion/react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link} from 'react-router-dom';

import auth from '../auth';

export default ({children}) => {
  const history = useHistory();
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    auth.student()
      .then((res) => {
        const student = res.data;
        if ( student && ! student.email ) {
          history.push('/student/confirm');
        }
        setLoaded(true);
      });
  }, []);
  if ( !loaded ) return <></>;

  return children;
};
